import { Divider } from 'antd';
import { IWidget } from 'common/schema/widget/Widget';
import React from 'react';

export interface IFormWidgetGraphicDividerViewProps {
  widget: IWidget;
}

/**
 * Non dovrebbe mai essere renderizzato dato che non viene
 * inserito nella lista dei widget al momento della costruzione
 * del form.
 */
export function FormWidgetGraphicDividerView(
  props: IFormWidgetGraphicDividerViewProps
) {
  const {} = props;
  return <Divider>{props.widget?.graphic!.content}</Divider>;
}
